import React, { createContext, useState, useContext, useEffect } from 'react';
import axiosInstance from "../axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [activeSubscription, setActiveSubscribtion] = useState(true);
    const [isTrial, setIsTrial] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isOwner, setIsOwner] = useState(false)
    const [can_edit_text, setCan_edit_text] = useState(false)
    const [can_edit_layout, setCan_edit_layout] = useState(false)
    const [needsConsents, setNeedsConsents] = useState(false);
    const [consents, setConsents] = useState({
        termsAccepted: false,
        privacyPolicyAccepted: false,
    });

    // Expose a reusable refresher to update auth-related flags on demand
    const refreshAuth = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await axiosInstance.get('/check-subscription', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            setActiveSubscribtion(res.data.isActive);
            setIsTrial(res.data.isTrial);
            setIsAdmin(res.data.isAdmin);
            setIsOwner(res.data.isOwner);
            setCan_edit_text(res.data.can_edit_text);
            setCan_edit_layout(res.data.can_edit_layout);
            setNeedsConsents(Boolean(res.data.needsConsents));
            setConsents({
                termsAccepted: Boolean(res.data.termsAccepted),
                privacyPolicyAccepted: Boolean(res.data.privacyPolicyAccepted),
            });
            return res.data;
        } catch (error) {
            console.error('Nie udało się odświeżyć statusu użytkownika:', error);
            throw error;
        }
    };

    useEffect(() => {

        const fetchUserData = async () => {
            try {
                await refreshAuth();
            } catch (error) {
                alert('coś poszło nie tak');
            }
        }

        const verifyToken = async () => {
          try {
            const token = localStorage.getItem("token");
            if (!token) {
                setIsLoggedIn(false);
              return;
            }
    
            await axiosInstance.get("/verify-token");
            setIsLoggedIn(true);
            await fetchUserData();
          } catch (err) {
            console.error("Token verification failed:", err);
            setIsLoggedIn(false);
          } finally {
            setIsLoading(false);
          }
        };
        verifyToken();
      }, [isLoggedIn]);

    return (
      <AuthContext.Provider value={{
        isLoggedIn,
        setIsLoggedIn,
        activeSubscription,
        // setActiveSubscribtion,
        isTrial,
        // setIsTrial,
        isAdmin,
        isLoading,
        setIsLoading,
        isOwner,
        can_edit_text,
        can_edit_layout,
        refreshAuth,
        needsConsents,
        setNeedsConsents,
        consents,
        setConsents
    }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
